import { render, staticRenderFns } from "./buy.vue?vue&type=template&id=97c3e70c&scoped=true&"
import script from "./buy.vue?vue&type=script&lang=js&"
export * from "./buy.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/buy.less?vue&type=style&index=0&id=97c3e70c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c3e70c",
  null
  
)

export default component.exports